/**
 * Mini-banner para el Dashboard que avisa de registros de producción
 * pendientes (atrasados más allá de la tolerancia). Click → navega a la
 * página de Producción Diaria.
 */
import React, { useEffect, useState } from 'react';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { getRegistrosFaltantes } from '../../lib/api';

export const RegistrosFaltantesBanner = () => {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    getRegistrosFaltantes({ dias_tolerancia: 2 })
      .then((res) => { if (mounted) setData(res.data); })
      .catch(() => { /* silencioso — no es crítico */ });
    return () => { mounted = false; };
  }, []);

  const total = data?.total_pendientes || 0;
  const fechas = data?.por_fecha?.length || 0;
  if (total === 0) return null;

  return (
    <Card
      className="border-amber-300 bg-amber-50/70 dark:border-amber-900/50 dark:bg-amber-950/30 cursor-pointer hover:bg-amber-100/70 dark:hover:bg-amber-950/50 transition-colors"
      onClick={() => navigate('/produccion')}
      data-testid="banner-faltantes-dashboard"
    >
      <CardContent className="py-2.5 px-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5 min-w-0">
          <AlertTriangle className="w-5 h-5 text-amber-600 dark:text-amber-400 shrink-0" />
          <div className="min-w-0">
            <p className="text-sm font-semibold text-amber-900 dark:text-amber-100 truncate" style={{ fontFamily: 'Space Grotesk' }}>
              {total} registro{total === 1 ? '' : 's'} de producción pendiente{total === 1 ? '' : 's'}
            </p>
            <p className="text-xs text-amber-800/80 dark:text-amber-200/80 truncate">
              {fechas} fecha{fechas === 1 ? '' : 's'} con atraso · click para revisar
            </p>
          </div>
        </div>
        <Button variant="ghost" size="sm" className="shrink-0 hover:bg-amber-200/60 dark:hover:bg-amber-900/40">
          Ir a Producción <ArrowRight className="w-4 h-4 ml-1" />
        </Button>
      </CardContent>
    </Card>
  );
};
